import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import EventIcon from "@mui/icons-material/Event";

const EmailConfirmationModal = ({
  open,
  onClose,
  selectedPerformers,
  eventInstance,
  onRemovePerformer,
  onSendEmails,
}) => {
  const [emailSubject, setEmailSubject] = useState(
    "Your Open Mic Night performance at The Cola"
  );
  const [emailBody, setEmailBody] = useState("");

  // Format date for display
  const formatDate = (date) => {
    if (!date) return "TBD";
    return date instanceof Date
      ? date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
          weekday: "long",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "Invalid date";
  };

  // Update the email template when the eventInstance changes
  useEffect(() => {
    if (eventInstance) {
      const eventDate = formatDate(eventInstance.startDate);

      setEmailSubject(
        `Your Open Mic Night performance at The Cola on ${
          eventDate.split(",")[0]
        }`
      );

      setEmailBody(
        `Pass That: Open Mic Night is a monthly event that showcases the best talent in the St. Louis area. Performers have the opportunity to share their comedy in a happy and high environment. 

The event is held at The Cola in the Cherokee neighborhood. You have been selected to perform on ${eventDate}. The event starts at 9:30 PM. Performers should arrive by 9 PM to check in. Performers will have 4 minutes to perform.

Please confirm your attendance by clicking the link in the confirmation email that will be sent to you.

The Cola is located at 2834 Cherokee St. St. Louis, MO 63118 in the Cherokee neighborhood. The venue is a cannabis lounge that serves a variety of drinks and treats. The venue is 21+ and has a full bar. Medical card holders 18+ are welcome.`
      );
    }
  }, [eventInstance]);

  const handleSend = async () => {
    await onSendEmails({ emailSubject, emailBody });
    onClose();
  };

  if (!eventInstance) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Confirm Email Send</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            Event Information
          </Typography>
          <Typography
            variant="body1"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <EventIcon sx={{ mr: 1 }} />
            {formatDate(eventInstance.startDate)}
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            Selected Performers
          </Typography>
          <List>
            {selectedPerformers.map((performer) => (
              <ListItem key={performer.id}>
                <ListItemText
                  primary={performer.stageName || performer.name}
                  secondary={performer.email}
                />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    onClick={() => onRemovePerformer(performer.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" gutterBottom>
          Email Preview
        </Typography>
        <TextField
          fullWidth
          label="Subject"
          value={emailSubject}
          onChange={(e) => setEmailSubject(e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Body"
          value={emailBody}
          onChange={(e) => setEmailBody(e.target.value)}
          multiline
          rows={8}
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSend}
          variant="contained"
          color="primary"
          disabled={selectedPerformers.length === 0}
        >
          Send Emails
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailConfirmationModal;
